export default [
  // 找不到網頁時回首頁
  {
    path: '*',
    redirect: '/',
    meta: {}
  }
]
